import { USER_URL } from "../../constants";
import axiosInstance from "./axiosInstance";

export const postContactUs = (name, email, message) =>
  axiosInstance.post(USER_URL + `/contact-us`, { name, email, message });

export const postBulkOrder = (countryName, region, MinOrderQuantity) =>
  axiosInstance.post(USER_URL + `/bulk-order-quote`, {  countryName, region, MinOrderQuantity});
